import React, { useEffect, useRef, useState } from 'react'
import { Formik, Form } from 'formik'
import { InputSocio, InputEstabelecimentoSaude, InputCirurgiaoCombo, InputSocioAtivos } from '../../../../components/InputsAutoCompleteV2'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mostrarToast } from '../../../../components/Toasts'
import { get, postComAcao } from '../../../../util/AcessoApi'
import { mensagens } from '../../../../util/Utilitarios'
import { ACOES, MODULO } from '../../../../util/Enums'
import { ModalDuasOpcoes, ModalPadraoCadastro } from '../../../../components/Modais'
import Yup from '../../../../util/Validacoes'
import { LoadRelatorio } from '../../../../components/Loading'

const ModalBloqueioSocio = props => {

    const [salvando, setSalvando] = useState(false)
    const refAtualizacao = useRef(null)
    const [initialValues, setInitialValues] = useState({
        socios: [],
        cirurgiao: {},
        estabelecimento_saude: {}
    })
    const [possuiSocio, setPossuiSocio] = useState(false)
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')
    const [sociosObtidos, setSociosObtidos] = useState(null)
    const [carregando, setCarregando] = useState(false)
    const [cirurgiao, setCirurgiao] = useState({})
    const [estabelecimentoSaude, setEstabelecimentoSaude] = useState({})

    const validationSchema = React.useMemo(() => {
        return Yup.object().shape({
            ...(props.cirurgiao && {
                cirurgiao: Yup.mixed()
                    .test(
                        'cirurgiao-required',
                        'Cirurgião é obrigatório',
                        (value) => {
                            if (Array.isArray(value)) {
                                return value.length > 0;
                            }
                            return value && Object.keys(value).length > 0;
                        }
                    )
            }),
            ...(props.estabelecimentoSaude && {
                estabelecimento_saude: Yup.mixed()
                    .test(
                        'estabelecimento-required',
                        'Estabelecimento de saúde é obrigatório',
                        (value) => {
                            if (Array.isArray(value)) {
                                return value.length > 0;
                            }
                            return value && Object.keys(value).length > 0;
                        }
                    )
            }),
            socios: Yup.array().nullable()
        });
    }, [props.cirurgiao, props.estabelecimentoSaude]);

    useEffect(() => {
        setInitialValues({
            socios: [],
            cirurgiao: props?.cirurgiao,
            estabelecimento_saude: props?.estabelecimentoSaude
        })
    }, [props.estabelecimentoSaude, props.cirurgiao])

    const submit = (values) => {
        setSalvando(true)

        postComAcao(
            ACOES.BLOQUEIO_SOCIO_CIRURGIAO,
            props.cirurgiao ? MODULO['/administracao/sociobloqueiocirurgiao'] : MODULO['/administracao/sociobloqueioestabelecimentosaude'],
            {
                cirurgiao: props.cirurgiao ? [values.cirurgiao].flat() : null,
                estabelecimento_saude: props.estabelecimentoSaude ? [values.estabelecimento_saude].flat() : null,
                socios: values.socios,
            },
            props.cirurgiao ? '/administracao/socioBloqueioCirurgiao' : '/administracao/socioBloqueioEstabelecimentoSaude',
            () => {
                mostrarToast('sucesso', 'Sócios bloqueados com sucesso')
                if (props.funcaoAposSalvar) {
                    props.funcaoAposSalvar()
                }
                setSalvando(false)
                props.setAbrirModal(false)
            },
            (erro) => {
                // mostrarToast('erro', mensagens.erro)
                setSalvando(false)
            }
        )
    }

    const obterSocioCirurgiao = (cirurgiao, option, propsFormik) => {
        if (!cirurgiao && (option?.length === 0 || !option)) {
            if (propsFormik)
                propsFormik.setFieldValue('socios', [])
            else
                propsFormik.setFieldValue('socios', [])
        }
        let params = {}
        if (Array.isArray(option)) {
            params = option[option.length - 1]
        } else
            params = cirurgiao || option

        if (params?.value)
            Promise.resolve(get('/administracao/obterSocioCirurgiao', { cirurgiao_id: params?.value }, true)).then(val => {

                let socios = propsFormik?.values?.socios || [];
                if (val && val[0]?.socios) {
                    setSociosObtidos(val[0].socios)

                    if (option?.length > 1) {
                        setShowModalValidacao(true)
                        setMensagemModal(`Já há sócio(s) definidos para o cirurgião selecionado (${params?.label}). Deseja continuar ?`)
                    } else {
                        setPossuiSocio(true)
                        socios = [...socios, ...val[0].socios];
                        socios = socios.filter((socio, index, self) =>
                            index === self.findIndex((s) => s.value === socio.value)
                        );
                        if (propsFormik)
                            propsFormik.setFieldValue('socios', socios);
                        else
                            setInitialValues({
                                socios: socios,
                                cirurgiao: params
                            })
                    }
                } else {
                    if (props?.cirurgiao?.value) {
                        setInitialValues({ cirurgiao: params })
                    } else {
                        propsFormik.setFieldValue('cirurgiao', option)
                        if (option?.value)
                            propsFormik.setFieldValue('socios', [])

                        else
                            propsFormik.setFieldValue('socios', socios)
                    }

                }
            })
    }
    const obterSocioEstabelecimento = (estabelecimento_saude, option, propsFormik) => {

        if (!estabelecimento_saude && (option?.length === 0 || !option)) {
            if (propsFormik)
                propsFormik.setFieldValue('socios', [])
            else
                propsFormik.setFieldValue('socios', [])
        }
        let params = {}
        if (Array.isArray(option)) {
            params = option[option.length - 1]
        } else
            params = estabelecimento_saude || option

        if (params?.value)
            Promise.resolve(get('/administracao/obterSocioEstabelecimento', { estabelecimento_id: params?.value }, true)).then(val => {

                let socios = propsFormik?.values?.socios || [];
                if (val && val[0]?.socios) {
                    setSociosObtidos(val[0].socios)

                    if (option?.length > 1) {
                        setShowModalValidacao(true)
                        setMensagemModal(`Já há sócio(s) definidos para o estabelecimento selecionado (${params?.label}). Deseja continuar ?`)
                    } else {
                        setPossuiSocio(true)
                        socios = [...socios, ...val[0].socios];
                        socios = socios.filter((socio, index, self) =>
                            index === self.findIndex((s) => s.value === socio.value)
                        );
                        if (propsFormik)
                            propsFormik.setFieldValue('socios', socios);
                        else
                            setInitialValues({
                                socios: socios,
                                estabelecimento_saude: params
                            })
                    }
                } else {
                    if (props?.estabelecimentoSaude?.value) {
                        setInitialValues({ estabelecimento_saude: params })
                    } else {
                        propsFormik.setFieldValue('estabelecimento_saude', option)
                        if (option?.value)
                            propsFormik.setFieldValue('socios', [])

                        else
                            propsFormik.setFieldValue('socios', socios)
                    }

                }
            })
    }

    useEffect(() => {

        if (props.estabelecimentoSaude) {

            obterSocioEstabelecimento(props.estabelecimentoSaude)
        }
        else if (props.cirurgiao) {
            obterSocioCirurgiao(props.cirurgiao)
        }
    }, [props.estabelecimentoSaude, props.cirurgiao])

    const obterCirurgiao = (idCirurgiao) => {
        console.log('idCirurgiao: ', idCirurgiao);
        setCarregando(true)
        Promise.resolve(get(`/administracao/cirurgiao/${idCirurgiao}`)).then(function (obj) {
            console.log('obj: ', obj);
            setCirurgiao(obj);
            // setSocios(obj.socio);
            // setValoresIniciais({ id: idCirurgiao, socio: obj.socio });
            setCarregando(false)
        }).catch((e) => {
            setCarregando(false)
        });
    }

    const obterEstabelecimento = (idEstabelecimento) => {
        setCarregando(true)
        Promise.resolve(get(`/administracao/estabelecimentoSaude/${idEstabelecimento}`)).then(function (obj) {
            console.log('obj: ', obj);
            setEstabelecimentoSaude(obj);
            // setSocios(obj.socio);
            // setValoresIniciais({ id: idCirurgiao, socio: obj.socio });
            setCarregando(false)
        }).catch((e) => {
            setCarregando(false)
        });
    }

    useEffect(() => {
        console.log('props.cirurgiao: ', props.cirurgiao);
        if (props.cirurgiao?.value)
            obterCirurgiao(props.cirurgiao?.value);
    }, [props.cirurgiao]);

    useEffect(() => {
        if (props.estabelecimentoSaude?.value)
            obterEstabelecimento(props.estabelecimentoSaude?.value);
    }, [props.estabelecimentoSaude]);

    const CirurgiaoInfo = () => {

        return (
            <div className={'form-group col-12'}>
                <label className={'width-100 bold'}>Código</label>
                <label className={'width-100 mb-20'}>{cirurgiao ? cirurgiao.id || '--' : '--'}</label>
                <label className={'width-100 bold'}>Nome Cirurgião</label>
                <label className={'width-100 mb-20'}>{cirurgiao ? cirurgiao.nome_cirurgiao || '--' : '--'}</label>
                <label className={'width-100 bold'}>Conselho Profissional</label>
                <label className={'width-100 mb-20'}>{cirurgiao ? cirurgiao.descricao || '--' : '--'}</label>
                <label className={'width-100 bold'}>N° Conselho</label>
                <label className={'width-100 mb-20'}>{cirurgiao && cirurgiao.crm ? (cirurgiao.crm + ' - ' + cirurgiao.crm_estado) || '--' : '--'}</label>
            </div>
        )
    }
    const EstabelecimentoSaudeInfo = () => {
        return (
            <div className={'form-group col-12'}>
                <label className={'width-100 bold'}>Código</label>
                <label className={'width-100 mb-20'}>{estabelecimentoSaude ? estabelecimentoSaude.id || '--' : '--'}</label>
                <label className={'width-100 bold'}>Identificação</label>
                <label className={'width-100 mb-20'}>{estabelecimentoSaude ? estabelecimentoSaude.codigo || '--' : '--'}</label>
                <label className={'width-100 bold'}>CNPJ</label>
                <label className={'width-100 mb-20'}>{estabelecimentoSaude ? estabelecimentoSaude?.cnpj || '--' : '--'}</label>
                <label className={'width-100 bold'}>Nome Fantasia</label>
                <label className={'width-100 mb-20'}>{estabelecimentoSaude && estabelecimentoSaude.nome_fantasia ? (estabelecimentoSaude.nome_fantasia) || '--' : '--'}</label>
            </div>
        )
    }


    const funcaoAposSim = (propsFormik) => {

        let socios = propsFormik.values.socios || [];
        socios = [...socios, ...sociosObtidos];

        socios = socios.filter((socio, index, self) =>
            index === self.findIndex((s) => s.value === socio.value)
        );

        propsFormik.setFieldValue('socios', socios);
        setShowModalValidacao(false);
    };

    const funcaoAposNao = (propsFormik) => {

        if (props.estabelecimentoSaude) {
            let estabelecimento = propsFormik.values.estabelecimento_saude

            estabelecimento = estabelecimento.slice(0, -1);
            propsFormik.setFieldValue('estabelecimento_saude', estabelecimento)
        }
        else if (props.cirurgiao) {
            let cirurgiao = propsFormik.values.cirurgiao

            cirurgiao = cirurgiao.slice(0, -1);
            propsFormik.setFieldValue('cirurgiao', cirurgiao)
        }

    }

    return (
        <ModalPadraoCadastro
            showModal={props.abrirModal}
            setShowModal={props.setAbrirModal}
            titulo="Bloqueio de Sócios"
            tamanho="md"
        >
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validationSchema={validationSchema}
                onSubmit={submit}
            >
                {propsFormik => (
                    <>
                        <div ref={refAtualizacao}>
                            {carregando ? (
                                <LoadRelatorio refLoading={refAtualizacao} height={320} />
                            ) : (
                                <Form>
                                    <div className="modal-body-cadastro">
                                        <div className="separator mt-10 mb-20"></div>
                                        <div className="form-group col-12">
                                            {props.cirurgiao ? (
                                                <CirurgiaoInfo idCirurgiao={props.cirurgiao?.value} />
                                            ) : (
                                                <EstabelecimentoSaudeInfo />
                                            )}
                                        </div>
                                    </div>
                                    <div className="row">
                                        <InputSocioAtivos
                                            label="Sócio(s)"
                                            name="socios"
                                            placeholder="Selecione os sócios para bloquear"
                                            propsFormik={propsFormik}
                                            multiplo
                                            autoFocus={
                                                props.estabelecimentoSaude
                                                    ? propsFormik.values.estabelecimento_saude?.value || propsFormik.values.estabelecimento_saude?.length > 0
                                                    : propsFormik.values.cirurgiao?.value || propsFormik.values.cirurgiao?.length > 0
                                            }
                                            classeTooltip="tooltip-input-modal"
                                        />
                                    </div>
                                    <div className="direita container-botoes mb-3 group-salvar-novo">
                                        <BotaoPadrao texto="Salvar" disabled={salvando} idTooltip="salvar" onClick={() => { }} />
                                    </div>
                                </Form>
                            )}
                        </div>

                        <ModalDuasOpcoes showModal={showModalValidacao} setShowModal={setShowModalValidacao} funcaoOpcao2={() => funcaoAposSim(propsFormik)} funcaoOpcao1={() => { funcaoAposNao(propsFormik); setShowModalValidacao(false) }}
                            esconderFechar mensagem={mensagemModal}
                            textoOpcao1={'Cancelar'}
                            classeOpcao1={'btn-sm btn-primary-modal simples'}
                            textoOpcao2={'Continuar'} />
                    </>
                )}
            </Formik>
        </ModalPadraoCadastro>

    );
}

export default ModalBloqueioSocio 